import { parseRoomCount } from '../ExploreListings/matchDetails';

/** Accepted buyer minimum, shared by full cards, compact cards and area labels.
 * Flexibility lowers the minimum by one, with one room as the lowest floor.
 * Callers omit invalid, non-finite or non-positive results.
 */
export const buyerRoomsFloor = (rooms: number | string, flexible?: boolean): number => {
  const minimum = parseRoomCount(rooms);
  if (minimum === null) return NaN;
  return flexible ? Math.max(1, minimum - 1) : minimum;
};
